module.exports = __webpack_public_path__ + "static/media/HackerNetworking.7e0d5fcc.png";